import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './views/Login';
import PanelSocio from './views/PanelSocio';
import PanelAdmin from './views/PanelAdmin';
import AltaSocio from './views/AltaSocio';
import BuscadorSocios from './views/BuscadorSocios';
import BuscadorHistorial from './views/BuscadorHistorial';
import EditarSocio from './views/EditarSocio';
import EditarAdmin from './views/EditarAdmin';
import CargaMasiva from './views/CargaMasiva';
import Socios2026 from './views/Socios2026';
import PrivateRoute from './components/PrivateRoute';
import { API_ENDPOINTS } from './config';

// Debug: Log API configuration
console.log('API Configuration:');
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('API_ENDPOINTS:', API_ENDPOINTS);

function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta pública - sin autenticación */}
        <Route path="/socios-2026" element={<Socios2026 />} />
        {/* Rutas principales */}
        <Route path="/login" element={<Login />} />
        <Route path="/socio" element={<PrivateRoute><PanelSocio /></PrivateRoute>} />
        <Route path="/admin" element={<PrivateRoute adminOnly={true}><PanelAdmin /></PrivateRoute>} />
        <Route path="/admin/alta" element={<PrivateRoute adminOnly={true}><AltaSocio /></PrivateRoute>} />
        <Route path="/admin/buscar-socios" element={<PrivateRoute adminOnly={true}><BuscadorSocios /></PrivateRoute>} />
        <Route path="/admin/buscar-historial" element={<PrivateRoute adminOnly={true}><BuscadorHistorial /></PrivateRoute>} />
        <Route path="/admin/carga-masiva" element={<PrivateRoute adminOnly={true}><CargaMasiva /></PrivateRoute>} />
        <Route path="/admin/editar" element={<PrivateRoute adminOnly={true}><EditarAdmin /></PrivateRoute>} />
        <Route path="/admin/editar-socio/:id" element={<PrivateRoute adminOnly={true}><EditarSocio /></PrivateRoute>} />
        <Route path="/admin/editar-admin/:id" element={<PrivateRoute adminOnly={true}><EditarAdmin /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
